import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import useAuth from '../context/useAuth';

const ProtectedRoute = ({ component: Component, allowedRoles, ...rest }) => {
  const { token, role } = useAuth();

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!token) {
          // Not logged in
          return <Redirect to="/login" />;
        } else if (allowedRoles && !allowedRoles.includes(role) && role !== 'admin') {
          // Logged in but not authorized
          return <Redirect to="/" />;
        } else {
          // Logged in and authorized
          return <Component {...props} />;
        }
      }}
    />
  );
};

export default ProtectedRoute;